module.exports = __webpack_public_path__ + "img/home-video.89da97a9.jpg";